import { PluginOwner } from "../../src/pluginsInfrastructure/PluginRegistryTypes";

export const productPageLayouts: PluginOwner = {
  ownerName: "Product Page Layouts",
  email: "ProductPageLayouts@vista.com",
  slack: "https://vistaprint.slack.com/archives/C057TK2884U",
  issueEscalation: "https://vista.pagerduty.com/teams/PNWWT9B/users",
};

export const productAdjacementInformation: PluginOwner = {
  ownerName: "Product Adjacent Information",
  email: "ProductAdjacentInfoEngineers@vista.com",
  slack: "https://vistaprint.slack.com/archives/C057R5YC70A",
  issueEscalation: "https://vista.pagerduty.com/teams/P6IZWXD/users",
};

export const addressAndMailingServices: PluginOwner = {
  ownerName: "Address & Mailing Services",
  email: "Addressing&MailingServicesEngineers@vista.com",
  slack: "https://vistaprint.slack.com/archives/C057N8LR153",
  issueEscalation: "https://vista.pagerduty.com/teams/PWAMMLE/users",
};

export const productOptions: PluginOwner = {
  ownerName: "Product Options",
  email: "ProductOptions@vista.com",
  slack: "https://vistaprint.slack.com/archives/C057FQY14CT",
  issueEscalation: "https://vista.pagerduty.com/teams/PEPDRXA/users",
};

export const astros: PluginOwner = {
  ownerName: "Astros",
  email: "astros@vista.com",
  slack: "https://vistaprint.slack.com/archives/C03MVHFF0MD",
  issueEscalation: "https://vista.pagerduty.com/escalation_policies/#P1SEMWV",
};

export const payments: PluginOwner = {
  ownerName: "Payments Squad",
  email: "payments-dev@vista.com",
  slack: "https://vistaprint.slack.com/archives/CB510F16G",
  issueEscalation: "https://vista.pagerduty.com/service-directory/PMOPSYM",
};
